<div style="min-height: 400px">
  <div class="sh-template-stack">
    <section class="sh-template-stack__item">
      @if (showSearch) {
        <med-thesaurus-search
          [thesaurusDefDottedKey]="(thesaurusFieldDefinition$ | async)?.DottedKey"
          [thesaurusSearchControl]="thesaurusSearchControl"
          [enableSuggestions]="enableSuggestions"
          [suggestionLimitReached]="suggestionLimit$ | async"
          [topConcept]="searchTopConcept$ | async"
          [multiple]="selectMultiple"
          [autoFocus]="autoFocus"
          (selectedConcept)="onLookupSelection($event)"
          (suggestion)="onSuggestion($event)"
        ></med-thesaurus-search>
      }
    </section>
    <section class="sh-template-stack__item">
      @if ((tags$ | async)?.options.length > 0 || (suggestions$ | async)?.length > 0) {
        <med-thesaurus-tag-list
          [id]="id + '-dialog'"
          [disabled]="disabled"
          [multiple]="selectMultiple"
          [placeholderMsg]=""
          [tags]="tags$ | async"
          [suggestions]="suggestions$ | async"
          [removableSuggestions]="false"
          (valueRemoved)="removeValue($event)"
          >
        </med-thesaurus-tag-list>
      }
      @if (suggestionErrorMsg$ | async; as errorMsg) {
        <p [style]="'color: red;'" class="sh-form-group__feedback">{{ errorMsg }}</p>
      }
    </section>

    <section class="sh-template-stack__item">
      @if (treeViewNodes$ | async; as treeViewNodes) {
        <sh-tree-viewer
          [nodes]="treeViewNodes"
          [hideRootNodes]="hideRootNodes"
          [multiple]="selectMultiple"
          [loadingMsg]="'thesaurus.loading' | translate"
          [loadMoreMsg]="'thesaurus.load-more' | translate"
          [getChildrenFct]="getNodeNarrowerConcepts"
          (selectedNodes)="onSelectedNodesChange($event)"
          (deselectedNodes)="onDeselectNodes($event)"
          (updatedNodes)="onUpdatedNodes($event)"
        ></sh-tree-viewer>
      }
    </section>
  </div>
</div>
